/**
 *
 * If it is needed custom loading tex use
 * {
 *     url: '/CaseTask/Search',
 *    headerText: 'Processing action custom text',
 *    bodyText: 'This may take a few seconds- custom text'
 *  }
 */

import { ReferenceDataLabels } from 'rome-library';

export class UiLoaderConfig {
  public static readonly EXCLUDED_ENDPOINTS = [
    '/ApplicationCase/IsNotificationAvailable',
    '/SessionCheck/Check',
    '/ApplicationCase/PaymentStatus',
    '/ApplicationCase/GetCaseRequests',
    '/ApplicationCase/GetCaseRequestsStatuses',
    '/PaymentOperationStatus/GetPaymentOperationStatus'
  ];
  public static readonly CUSTOM_ENDPOINTS = [
    {
      url: '/PlaceholderUpload/UploadDocuments',
      headerText: ReferenceDataLabels.PlaceholderUploadingInProgress,
      bodyText: ''
    },
    {
      url: '/Applications/Submit',
      headerText: ReferenceDataLabels.ProgressBarSubmitAppHeader,
      bodyText: ReferenceDataLabels.ProgressBarSubmitAppBody
    },
    {
      url: '/Applications/Validate',
      headerText: ReferenceDataLabels.ProgressBarSubmitAppHeader,
      bodyText: ReferenceDataLabels.ProgressBarSubmitAppBody
    },
    {
      url: '/AdviceCaseManagement/SubmitAdvice',
      headerText: ReferenceDataLabels.ProgressBarSubmitAppHeader,
      bodyText: ReferenceDataLabels.ProgressBarSubmitAppBody
    },
    {
      url: '/Applications/SaveApplication',
      headerText: ReferenceDataLabels.ProgressBarDefaultHeader,
      bodyText: ReferenceDataLabels.ProgressBarDefaultBody
    },
    {
      url: '/PlaceholderUpload/GetUploadSettings',
      headerText: ReferenceDataLabels.ProgressBarDefaultHeader,
      bodyText: ReferenceDataLabels.ProgressBarDefaultBody
    }
  ];
}
